// tslint:disable
/**
 * Access Control
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { IdentifyThingRequest } from '../models';
import { PowerStatus } from '../models';
import { PropertyThingPaginatedListResponse } from '../models';
import { ThingLocationType } from '../models';
import { ThingType } from '../models';
/**
 * ThingApi - axios parameter creator
 * @export
 */
export const ThingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {string} [continuationToken]
     * @param {number} [limit]
     * @param {string} [thingIdentifier]
     * @param {ThingLocationType} [thingLocationType]
     * @param {ThingType} [thingType]
     * @param {PowerStatus} [thingStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingExportGet(
      propertyId: string,
      continuationToken?: string,
      limit?: number,
      thingIdentifier?: string,
      thingLocationType?: ThingLocationType,
      thingType?: ThingType,
      thingStatus?: PowerStatus,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling thingExportGet.'
        );
      }
      const localVarPath = `/thing/export`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (continuationToken !== undefined) {
        localVarQueryParameter['ContinuationToken'] = continuationToken;
      }

      if (limit !== undefined) {
        localVarQueryParameter['Limit'] = limit;
      }

      if (propertyId !== undefined) {
        localVarQueryParameter['PropertyId'] = propertyId;
      }

      if (thingIdentifier !== undefined) {
        localVarQueryParameter['ThingIdentifier'] = thingIdentifier;
      }

      if (thingLocationType !== undefined) {
        localVarQueryParameter['ThingLocationType'] = thingLocationType;
      }

      if (thingType !== undefined) {
        localVarQueryParameter['ThingType'] = thingType;
      }

      if (thingStatus !== undefined) {
        localVarQueryParameter['ThingStatus'] = thingStatus;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} [continuationToken]
     * @param {number} [limit]
     * @param {string} [thingIdentifier]
     * @param {ThingLocationType} [thingLocationType]
     * @param {ThingType} [thingType]
     * @param {PowerStatus} [thingStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingGet(
      propertyId: string,
      continuationToken?: string,
      limit?: number,
      thingIdentifier?: string,
      thingLocationType?: ThingLocationType,
      thingType?: ThingType,
      thingStatus?: PowerStatus,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling thingGet.'
        );
      }
      const localVarPath = `/thing`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (continuationToken !== undefined) {
        localVarQueryParameter['ContinuationToken'] = continuationToken;
      }

      if (limit !== undefined) {
        localVarQueryParameter['Limit'] = limit;
      }

      if (propertyId !== undefined) {
        localVarQueryParameter['PropertyId'] = propertyId;
      }

      if (thingIdentifier !== undefined) {
        localVarQueryParameter['ThingIdentifier'] = thingIdentifier;
      }

      if (thingLocationType !== undefined) {
        localVarQueryParameter['ThingLocationType'] = thingLocationType;
      }

      if (thingType !== undefined) {
        localVarQueryParameter['ThingType'] = thingType;
      }

      if (thingStatus !== undefined) {
        localVarQueryParameter['ThingStatus'] = thingStatus;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {IdentifyThingRequest} [identifyThingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingPropertyIdIdentifyPut(
      propertyId: string,
      identifyThingRequest?: IdentifyThingRequest,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling thingPropertyIdIdentifyPut.'
        );
      }
      const localVarPath = `/thing/{propertyId}/identify`.replace(
        `{${'propertyId'}}`,
        encodeURIComponent(String(propertyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof identifyThingRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(identifyThingRequest !== undefined ? identifyThingRequest : {})
        : identifyThingRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingPropertyIdThermostatThingNameRequestUpdatePost(
      propertyId: string,
      thingName: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling thingPropertyIdThermostatThingNameRequestUpdatePost.'
        );
      }
      // verify required parameter 'thingName' is not null or undefined
      if (thingName === null || thingName === undefined) {
        throw new RequiredError(
          'thingName',
          'Required parameter thingName was null or undefined when calling thingPropertyIdThermostatThingNameRequestUpdatePost.'
        );
      }
      const localVarPath = `/thing/{propertyId}/thermostat/{thingName}/request-update`
        .replace(`{${'propertyId'}}`, encodeURIComponent(String(propertyId)))
        .replace(`{${'thingName'}}`, encodeURIComponent(String(thingName)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingPropertyIdThingNameDelete(
      propertyId: string,
      thingName: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling thingPropertyIdThingNameDelete.'
        );
      }
      // verify required parameter 'thingName' is not null or undefined
      if (thingName === null || thingName === undefined) {
        throw new RequiredError(
          'thingName',
          'Required parameter thingName was null or undefined when calling thingPropertyIdThingNameDelete.'
        );
      }
      const localVarPath = `/thing/{propertyId}/{thingName}`
        .replace(`{${'propertyId'}}`, encodeURIComponent(String(propertyId)))
        .replace(`{${'thingName'}}`, encodeURIComponent(String(thingName)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ThingApi - functional programming interface
 * @export
 */
export const ThingApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {string} [continuationToken]
     * @param {number} [limit]
     * @param {string} [thingIdentifier]
     * @param {ThingLocationType} [thingLocationType]
     * @param {ThingType} [thingType]
     * @param {PowerStatus} [thingStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingExportGet(
      propertyId: string,
      continuationToken?: string,
      limit?: number,
      thingIdentifier?: string,
      thingLocationType?: ThingLocationType,
      thingType?: ThingType,
      thingStatus?: PowerStatus,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
      const localVarAxiosArgs = ThingApiAxiosParamCreator(configuration).thingExportGet(
        propertyId,
        continuationToken,
        limit,
        thingIdentifier,
        thingLocationType,
        thingType,
        thingStatus,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} [continuationToken]
     * @param {number} [limit]
     * @param {string} [thingIdentifier]
     * @param {ThingLocationType} [thingLocationType]
     * @param {ThingType} [thingType]
     * @param {PowerStatus} [thingStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingGet(
      propertyId: string,
      continuationToken?: string,
      limit?: number,
      thingIdentifier?: string,
      thingLocationType?: ThingLocationType,
      thingType?: ThingType,
      thingStatus?: PowerStatus,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<PropertyThingPaginatedListResponse> {
      const localVarAxiosArgs = ThingApiAxiosParamCreator(configuration).thingGet(
        propertyId,
        continuationToken,
        limit,
        thingIdentifier,
        thingLocationType,
        thingType,
        thingStatus,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {IdentifyThingRequest} [identifyThingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingPropertyIdIdentifyPut(
      propertyId: string,
      identifyThingRequest?: IdentifyThingRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = ThingApiAxiosParamCreator(configuration).thingPropertyIdIdentifyPut(
        propertyId,
        identifyThingRequest,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingPropertyIdThermostatThingNameRequestUpdatePost(
      propertyId: string,
      thingName: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = ThingApiAxiosParamCreator(
        configuration
      ).thingPropertyIdThermostatThingNameRequestUpdatePost(propertyId, thingName, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingPropertyIdThingNameDelete(
      propertyId: string,
      thingName: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = ThingApiAxiosParamCreator(
        configuration
      ).thingPropertyIdThingNameDelete(propertyId, thingName, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * ThingApi - factory interface
 * @export
 */
export const ThingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {string} [continuationToken]
     * @param {number} [limit]
     * @param {string} [thingIdentifier]
     * @param {ThingLocationType} [thingLocationType]
     * @param {ThingType} [thingType]
     * @param {PowerStatus} [thingStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingExportGet(
      propertyId: string,
      continuationToken?: string,
      limit?: number,
      thingIdentifier?: string,
      thingLocationType?: ThingLocationType,
      thingType?: ThingType,
      thingStatus?: PowerStatus,
      options?: any
    ): AxiosPromise<any> {
      return ThingApiFp(configuration).thingExportGet(
        propertyId,
        continuationToken,
        limit,
        thingIdentifier,
        thingLocationType,
        thingType,
        thingStatus,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} [continuationToken]
     * @param {number} [limit]
     * @param {string} [thingIdentifier]
     * @param {ThingLocationType} [thingLocationType]
     * @param {ThingType} [thingType]
     * @param {PowerStatus} [thingStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingGet(
      propertyId: string,
      continuationToken?: string,
      limit?: number,
      thingIdentifier?: string,
      thingLocationType?: ThingLocationType,
      thingType?: ThingType,
      thingStatus?: PowerStatus,
      options?: any
    ): AxiosPromise<PropertyThingPaginatedListResponse> {
      return ThingApiFp(configuration).thingGet(
        propertyId,
        continuationToken,
        limit,
        thingIdentifier,
        thingLocationType,
        thingType,
        thingStatus,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {string} propertyId
     * @param {IdentifyThingRequest} [identifyThingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingPropertyIdIdentifyPut(
      propertyId: string,
      identifyThingRequest?: IdentifyThingRequest,
      options?: any
    ): AxiosPromise<void> {
      return ThingApiFp(configuration).thingPropertyIdIdentifyPut(
        propertyId,
        identifyThingRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingPropertyIdThermostatThingNameRequestUpdatePost(
      propertyId: string,
      thingName: string,
      options?: any
    ): AxiosPromise<void> {
      return ThingApiFp(configuration).thingPropertyIdThermostatThingNameRequestUpdatePost(
        propertyId,
        thingName,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    thingPropertyIdThingNameDelete(
      propertyId: string,
      thingName: string,
      options?: any
    ): AxiosPromise<void> {
      return ThingApiFp(configuration).thingPropertyIdThingNameDelete(
        propertyId,
        thingName,
        options
      )(axios, basePath);
    },
  };
};

/**
 * ThingApi - object-oriented interface
 * @export
 * @class ThingApi
 * @extends {BaseAPI}
 */
export class ThingApi extends BaseAPI {
  /**
   *
   * @param {string} propertyId
   * @param {string} [continuationToken]
   * @param {number} [limit]
   * @param {string} [thingIdentifier]
   * @param {ThingLocationType} [thingLocationType]
   * @param {ThingType} [thingType]
   * @param {PowerStatus} [thingStatus]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThingApi
   */
  public thingExportGet(
    propertyId: string,
    continuationToken?: string,
    limit?: number,
    thingIdentifier?: string,
    thingLocationType?: ThingLocationType,
    thingType?: ThingType,
    thingStatus?: PowerStatus,
    options?: any
  ) {
    return ThingApiFp(this.configuration).thingExportGet(
      propertyId,
      continuationToken,
      limit,
      thingIdentifier,
      thingLocationType,
      thingType,
      thingStatus,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {string} propertyId
   * @param {string} [continuationToken]
   * @param {number} [limit]
   * @param {string} [thingIdentifier]
   * @param {ThingLocationType} [thingLocationType]
   * @param {ThingType} [thingType]
   * @param {PowerStatus} [thingStatus]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThingApi
   */
  public thingGet(
    propertyId: string,
    continuationToken?: string,
    limit?: number,
    thingIdentifier?: string,
    thingLocationType?: ThingLocationType,
    thingType?: ThingType,
    thingStatus?: PowerStatus,
    options?: any
  ) {
    return ThingApiFp(this.configuration).thingGet(
      propertyId,
      continuationToken,
      limit,
      thingIdentifier,
      thingLocationType,
      thingType,
      thingStatus,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {string} propertyId
   * @param {IdentifyThingRequest} [identifyThingRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThingApi
   */
  public thingPropertyIdIdentifyPut(
    propertyId: string,
    identifyThingRequest?: IdentifyThingRequest,
    options?: any
  ) {
    return ThingApiFp(this.configuration).thingPropertyIdIdentifyPut(
      propertyId,
      identifyThingRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {string} propertyId
   * @param {string} thingName
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThingApi
   */
  public thingPropertyIdThermostatThingNameRequestUpdatePost(
    propertyId: string,
    thingName: string,
    options?: any
  ) {
    return ThingApiFp(this.configuration).thingPropertyIdThermostatThingNameRequestUpdatePost(
      propertyId,
      thingName,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {string} propertyId
   * @param {string} thingName
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThingApi
   */
  public thingPropertyIdThingNameDelete(propertyId: string, thingName: string, options?: any) {
    return ThingApiFp(this.configuration).thingPropertyIdThingNameDelete(
      propertyId,
      thingName,
      options
    )(this.axios, this.basePath);
  }
}
